import React from 'react';

import SimpleContainer from '../../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../../containers/categorycontainer/CategoryContainer';

import backgroundImage from '../../media/help-and-guides/what-is-air-pollution.jpeg';

import 'bootstrap/dist/css/bootstrap.css';

import { PageText, Categories } from '../../input-text/en/help-and-guides/what-is-air-pollution_page';

class AircheckrNewsletter extends React.Component {

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container' backgroundImage={backgroundImage}>
          <div className='col-sm-offset-4 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p>{PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._1 } />
        <CategoryContainer cols='1' category={ Categories._2 } />
        <CategoryContainer cols='1' category={ Categories._3 } />
        <CategoryContainer cols='1' category={ Categories._4 } />
      </div>
    );
  }
};

export default AircheckrNewsletter;



// WEBPACK FOOTER //
// ./src/routes/help-and-guides/WhatIsAirPollution.js